import { Component, OnInit } from '@angular/core';
import { CommonService, UserService } from '../services/common';
import { JwtService } from '../auth/jwtservice';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { VaultStateService } from '../vault/services/vault-state.service';
import { TokenPropertyUrl } from '../../appconfig';

@Component({
  selector: 'app-user-account-profile',
  templateUrl: './user-account-profile.component.html',
  styleUrl: './user-account-profile.component.scss'
})

export class UserAccountProfileComponent implements OnInit {

  currentUserName: any
  userLogList: any
  userRoleList: any
  columnDefs!: any[];
  isLogViewer: boolean = false; //decides if log option to be shown to current user or not based on role

  private destroy$ = new Subject<void>();
  isModalOpen: boolean = false;
  isLoadingLogs: boolean = false;

  menuItems = [
    { key: 'account', label: 'Account', icon: 'bi bi-person' },
    { key: 'password', label: 'Change Password', icon: 'bi bi-lock' },
  ];

  selectedMenu = 'logs';
  private keyHandler!: (e: KeyboardEvent) => void;

  constructor(private commonService: CommonService, private userService: UserService, public jwtService: JwtService,
    private vaultState: VaultStateService) { }

  ngOnInit(): void {
    this.setColumnDefs()
    this.currentUserName = this.commonService.getLoggedInUserName();
    this.getUserLogList()
    this.getUserRoleList();

    this.isLogViewer = this.jwtService.isCurrentUserInRole('Self_Log_View') || this.jwtService.isCurrentUserInRole('All_Log_View');

    //if user has permission to view logs, show the menu item
    if (this.isLogViewer) {
      this.menuItems.push({ key: 'logs', label: 'Logs', icon: 'bi bi-list' })
    }
    else
      this.selectedMenu = 'password'

    this.attachSecretKeyListener();

    // Subscribe to modal state to control body scroll
    this.commonService.showUserProfileModal
      .pipe(takeUntil(this.destroy$))
      .subscribe((isOpen: boolean) => {
        this.isModalOpen = isOpen;
        this.toggleBodyScroll(isOpen);
      });
  }

  setColumnDefs() {
    this.columnDefs = [
      { field: 'selection', columnType: 'checkbox' },
      { header: 'User Name', field: 'userName', columnType: 'text' },
      { header: 'Activity Time', field: 'logTime', columnType: 'date', config: { dateFormat: "dd-MMM-yyyy hh:mm a" } },
      { header: 'Activity', field: 'apiendpoint', columnType: 'text' },
      { header: 'Action', field: 'apitype', columnType: 'text' },
      { header: 'Status', field: 'status', columnType: 'text', tooltipField: 'status' },
    ]
  }

  getUserLogList() {
    this.isLoadingLogs = true;
    this.userService.getUsersUserName(this.jwtService.getUserPropertyValueFromToken(TokenPropertyUrl.userId)).subscribe((res: any) => {
      if (res && res?.result) {
        this.currentUserName = res?.result;
        if (this.jwtService.isCurrentUserInRole('All_Log_View')) {
          this.currentUserName = null; //fetch all logs
        }

        const sevenDaysEarlier = new Date(Date.now() - 15 * 24 * 60 * 60 * 1000);
        const formattedDate = `${String(sevenDaysEarlier.getMonth() + 1).padStart(2, '0')}/${String(sevenDaysEarlier.getDate()).padStart(2, '0')}/${sevenDaysEarlier.getFullYear()}`;
        this.userService.filterUserLogs(this.currentUserName, 'login', null, formattedDate).subscribe(res => {
          if (res && res?.result) {
            this.userLogList = res?.result.map((log: any) => {
              // Convert GMT logTime to local timezone
              // if (log?.logTime) {
              //   log.logTime = this.commonService.convertGmtToLocalTimezone(log.logTime, false);
              // }
              log.apitype = (log?.apitype?.toLowerCase() == 'post' && log?.apiendpoint?.toLowerCase() == 'login') ? 'Login Attempt' : log?.action
              log.status = log?.responseReason.toLowerCase() == 'login success' ? 'Success' : log?.responseReason
              return log
            })
          }
          this.isLoadingLogs = false;
        }, (error) => {
          this.isLoadingLogs = false;
        })
      }
    });

  }

  getUserRoleList() {
    this.userRoleList = this.jwtService.currentUserRolesValue;
  }

  selectMenu(key: string) {
    this.selectedMenu = key;
    if (key.toLowerCase() == 'logs' && !this.userLogList) {
      this.getUserLogList()
    }
  }

  closeUserProfileModal() {
    this.commonService.showUserProfileModal.next(false)
  }

  // 🔒 DISABLE BACKGROUND SCROLL WHEN MODAL OPENS
  private toggleBodyScroll(disable: boolean): void {
    if (disable) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }


  // 🔐 SECRET KEY LISTENER
  private attachSecretKeyListener() {
    this.keyHandler = (e: KeyboardEvent) => {

      // Ignore typing in inputs/textareas
      const target = e.target as HTMLElement;
      if (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable
      ) {
        return;
      }

      // Secret combo: ALT + A
      if (e.altKey && e.key.toLowerCase() === 'a') {

        // Optional: only allow admin
        if (!this.jwtService.isCurrentUserInRole('Vault_Admin')) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();

        this.openVaultAmendment();
      }
    };

    document.addEventListener('keydown', this.keyHandler);
  }

  private detachSecretKeyListener() {
    if (this.keyHandler) {
      document.removeEventListener('keydown', this.keyHandler);
    }
  }

  // 🔥 OPEN VAULT MODAL
  openVaultAmendment() {
    // this.commonService.openVaultAmendmentModal();
    this.vaultState.open();
  }


  ngOnDestroy(): void {
    // Signal completion to clean up subscriptions
    this.detachSecretKeyListener();
    this.toggleBodyScroll(false); // Re-enable scrolling when component is destroyed
    this.destroy$.next();
    this.destroy$.complete();
  }

}
